import { RolesEnum } from "../../../Enum/roles.enum";
import { RootTypeEnum } from "../../../Enum/root-type.enum";
import { VehicleStatus } from "../../../Enum/vehcile-status.enum";
import { VehicletypeEnum } from "../../../Enum/vehicle-type.enum";

export class VehicleReqDto{
    id: number
    employeeId: number;
    source: number;
    destination: number;
    noOfPeople: string;
    vehicleRequiredOn: Date;
    hodApprovalDate: Date;
    adminApprovalDate: Date;
    vehicleType: VehicletypeEnum;
    vehicleId: number;
    vendorId: number;
    cost: number;
    distance: number;
    status: VehicleStatus;
    isActive: boolean;
    createdUser: string | null;
    createdAt: Date;
    updatedUser: string | null;
    vehiclePreference:number
    vehiclePurpose:string
    departmentId:number
    pickUpTime:string
    requestedFor:RolesEnum
    type:RootTypeEnum
    userContact?:string


    constructor(
        id?: number,
        employeeId?: number,
        source?: number,
        destination?: number,
        noOfPeople?: string,
        vehicleRequiredOn?: any,
        hodApprovalDate?: Date,
        adminApprovalDate?: Date,
        vehicleType?: VehicletypeEnum,
        vehicleId?: number,
        vendorId?: number,
        cost?: number,
        distance?: number,
        status?: VehicleStatus,
        isActive?: boolean,
        createdUser?: string | null,
        createdAt?: Date,
        updatedUser?: string | null,
        vehiclePreference?:number,
        vehiclePurpose?:string,
        departmentId?:number,
        pickUpTime?:string,
        requestedFor?:RolesEnum,
        type?:RootTypeEnum,
        userContact?:string
    ){
        this.vehiclePreference=vehiclePreference
        this.vehiclePurpose=vehiclePurpose
        this.id=id
        this.employeeId=employeeId
        this.source=source
        this.destination=destination
        this.noOfPeople=noOfPeople
        this.vehicleRequiredOn=vehicleRequiredOn
        this.hodApprovalDate=hodApprovalDate
        this.adminApprovalDate=adminApprovalDate
        this.vehicleType=vehicleType
        this.vehicleId=vehicleId
        this.vendorId=vendorId
        this.cost=cost
        this.distance=distance
        this.status=status
        this.isActive=isActive
        this.createdUser=createdUser
        this.updatedUser=updatedUser
        this.createdAt=createdAt
        this.departmentId=departmentId
        this.pickUpTime=pickUpTime 
        this.requestedFor=requestedFor 
        this.type=type  
        this.userContact=userContact        
    }

}